<template>
  <div>
    <div class="modal loading-modal" :class="{'is-active': loading}">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="sp sp-circle">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'app-header',
  mixins: [],
  components: {},
  data() {
    return {}
  },
  props: {
    loading: Boolean
  },
  watch: {
    loading: function (val, oldval) {
      if (!val) {
        document.getElementById("header-bar").scrollIntoView();
      }
    }
  },
  created() {
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/journey/Loading.vue